import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ReservationState } from "src/model/enum/enumReservation";
import { Reservation } from "src/model/interface/reservation";

@Component({
    selector: "app-reservation-state-icon",
    templateUrl: "./reservation-state-icon.component.html",
    styleUrls: ["./reservation-state-icon.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReservationStateIconComponent implements OnInit {
  public cssComponentClass: string = "";

  @Input() reservation: Reservation;

  constructor() {}

  ngOnInit() {
    this.getComponentStyleByReservationState();
  }

  /**
   * Get css class to color component icon by reservation state
   */
  private getComponentStyleByReservationState(): void {
    switch (this.reservation.state) {
      case ReservationState.ARCHIVED:
        this.cssComponentClass = "archived";
        break;
      case ReservationState.ASSIGNED:
      case ReservationState.BOOKED:
        this.cssComponentClass = "booked";
        break;
      case ReservationState.CHECK_IN:
        this.cssComponentClass = "check-in";
        break;
      case ReservationState.MAINTANANCE:
        this.cssComponentClass = "maintanance";
        break;
      case ReservationState.TEMPORARY:
        this.cssComponentClass = "temporary";
        break;
    }
  }
}
